import Router from 'next/router';
import { getCookie } from '@/utils/helpers/getCookie';
import CONFIG from 'config';

import axios from 'axios';
import { httpServiceTexts } from '@/assets/strings';

const getTokenLocalStorage = () => {
  return window?.localStorage.getItem('ho-token');
};

const getToken = () => {
  const tokenCookieSide = getCookie('t_token');
  const queryParam = new URLSearchParams(window.location.search).get('token');
  if (queryParam) window?.localStorage.setItem('ho-token', queryParam);
  const tokenLocalStorageSide = getTokenLocalStorage();
  return tokenCookieSide || tokenLocalStorageSide;
};

const merchantInstance = axios.create();

merchantInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    config.headers[httpServiceTexts.authorization] = token
      ? httpServiceTexts.bearer + token
      : null;
    config.headers[httpServiceTexts.contentType] =
      httpServiceTexts.applicationJson;
    config.headers['X-UserType'] = 'merchant';

    return config;
  },
  async (error) => {
    await (window as any).newrelic.noticeError(error);
    Promise.reject(error);
  }
);

merchantInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      Router.replace(CONFIG.ENDPOINTS.returnPage);
      (window as any).newrelic.noticeError(error);

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export const httpGet = <T>(url: string): Promise<T> => {
  return merchantInstance.get(CONFIG.URL.base + url);
};

export const httpPut = <T>(url: string, body: any): Promise<T> => {
  return merchantInstance.put(CONFIG.URL.base + url, body);
};

export const httpPost = <T>(url: string, body: any): Promise<T> => {
  return merchantInstance.post(CONFIG.URL.base + url, body);
};
